<template>
  <v-app>
    <v-content>
      <wacg-widget ></wacg-widget>
    </v-content>
  </v-app>
</template>

<script>
import wacgWidget from './components/wacg-widget'
export default {
  name: 'App',
  components: {
    wacgWidget
  },
  data: () => ({
    //
  }),
};
</script>

<style lang="scss">

  @import "css/_colors.scss";
  @import "css/main.scss";
  @import "css/wacg-body.scss";
  @import "~tippy.js/dist/tippy.css";
  @import "assets/icons/style.css";
  @import "assets/icomoon/style.css";
  @font-face {
    font-family: '____';
    src: url('https://plugin.accessibilityeg.com/fonts/manissi-abjad-ishara-kabir.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }
</style>
